/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import axios from '@/api';
import router from '@/router';

// get all user
function getAll() {
  return axios
    .get('tutor/minors')
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

// aggiungi eccezione orario
function addArrivalExc(id, classroom, arrival) {
  const d = new Date();
  const n = d.getDate();
  const y = d.getFullYear();
  const m = d.getMonth() + 1;
  const data = {
    arrival_time: arrival,
    date: `${n}-${m}-${y}`,
  };
  return axios
    .post(`tutor/arrival-exception/minor/${id}/classroom/${classroom}`, data)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

// recupera eccezioni orario
function getArrivalExc(id, classroom) {
  return axios
    .get(`tutor/arrival-exception/minor/${id}/classroom/${classroom}?today=1`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

// modifica eccezioni orario
function updateArrivalExc(id, arrival) {
  const data = {
    arrival_time: arrival,
  };
  return axios
    .put(`tutor/arrival-exception/${id}`, data)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function getMinor(id, role) {
  let endpoint = 'tutor';
  if (role !== 'tutor') {
    endpoint = 'teacher';
  }
  return axios
    .get(`${endpoint}/minor/${id}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function updateMinor(user) {
  const id = user.id;
  return axios
    .put(`tutor/minor/${id}`, user)
    .then(() => {
      router.replace({ name: 'MinoreDettaglio', params: { id } });
    })
    .catch(error => Promise.reject(error));
}

function getAllByClass(id) {
  return axios
    .get(`teacher/classroom/${id}/minors`)
    .then(response => response)
    .catch(error => Promise.reject(error));
}

function getRollCallByClass(id) {
  return axios
    .get(`teacher/classroom/${id}/minors/rollcall`)
    .then(response => response)
    .catch(error => Promise.reject(error));
}

function getChildrenInClass(id) {
  return axios
    .get(`teacher/classroom/${id}/minors/presents`)
    .then(response => response)
    .catch(error => Promise.reject(error));
}

function changeMinorStatus(id, classroom) {
  return axios
    .post(`teacher/confirm_presence/classroom/${classroom}/minor/${id}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function confirmLeft(id, classroom) {
  return axios
    .post(`teacher/confirm_left/classroom/${classroom}/minor/${id}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function confirmAbsence(id, classroom) {
  return axios
    .post(`teacher/confirm_absence/classroom/${classroom}/minor/${id}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function showClassroomParents(minorId, classroomId) {
  return axios
    .get(`tutor/minor/${minorId}/classroom/${classroomId}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function getMinorsEvent(classroom_id, date) {
  return axios
    .get(`teacher/classrooms/${classroom_id}/events?date=${date}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

export const minoriService = {
  getAll,
  getAllByClass,
  changeMinorStatus,
  getMinor,
  updateMinor,
  addArrivalExc,
  getArrivalExc,
  updateArrivalExc,
  getRollCallByClass,
  getChildrenInClass,
  showClassroomParents,
  confirmLeft,
  confirmAbsence,
  getMinorsEvent,
};
